/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable react/function-component-definition */
/* eslint-disable spaced-comment */
/* eslint-disable no-extra-boolean-cast */
import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';

import BG_IMAGE from './cert_bg.png';
import { themeColor } from '../../../config/theme/themeVariables';

Font.register({
  family: 'MyFont_BOLD',
  fontWeight: 'bold',
  src: require('../../../static/fonts/Halagar.otf'),
});

Font.register({
  family: 'YearFont',
  fontWeight: 'bold',
  src: require('../../../static/fonts/temp.ttf'),
});

const styles = StyleSheet.create({
  heading: {
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: 'MyFont_BOLD',
  },
  yearHeading: {
    fontSize: 28,
    fontWeight: 'bold',
    fontFamily: 'YearFont',
    color: themeColor['error-color'],
  },
  memberNumber: {
    fontSize: 18,
    fontWeight: 'bold',
    fontFamily: 'YearFont',
    // color: themeColor['warning-hover'],
    color: themeColor.black,
    width: '100%',
    textAlign: 'center',
  },
  page: {
    backgroundColor: '#fff',
    fontSize: 12,
    padding: 10,
  },
  qrImage: {
    position: 'absolute',
    bottom: 152,
    right: 166,
    width: 92,
    height: 99,
    zIndex: 1000,
  },
  certificateNumber: {
    position: 'absolute',
    top: 38,
    left: 482,
    right: 20,
    zIndex: 1000,
  },
  companyName: {
    position: 'absolute',
    top: 407,
    left: 100,
    right: 36,
    zIndex: 1000,
  },
  year: {
    position: 'absolute',
    top: 440,
    left: 330,
    right: 1,
    zIndex: 1000,
  },
  signatureLeft: {
    position: 'absolute',
    top: 686,
    left: 30,
    zIndex: 1000,
    width: 200,
    height: 100,
  },
  signatureRight: {
    position: 'absolute',
    top: 686,
    right: 20,
    zIndex: 1000,
    width: 200,
    height: 100,
  },
  backgroundImage: {
    position: 'absolute',
    top: 1,
    left: 1,
    right: 1,
    bottom: 1,
    zIndex: 1003,
  },
});

const MyDocument = ({ certificateNumber, companyName, qrImage, sigChairman, sigSecGeneral, forYear }) => {
  const pageSize = 'A4';

  return (
    <Document>
      <Page size={pageSize} style={styles.page} fixed>
        <Image src={qrImage} style={styles.qrImage} />

        <View style={styles.certificateNumber}>
          <Text style={styles.memberNumber}>{certificateNumber}</Text>
        </View>

        <View style={{ ...styles.companyName, textAlign: 'center' }}>
          <Text style={styles.heading}>{companyName}</Text>
        </View>

        <View style={styles.year}>
          {/* <Text style={styles.yearHeading}>{moment().get('year')}</Text> */}
          <Text style={styles.yearHeading}>{forYear}</Text>
        </View>

        <Image src={sigSecGeneral} style={styles.signatureLeft} />
        <Image src={sigChairman} style={styles.signatureRight} />

        <Image src={BG_IMAGE} style={styles.backgroundImage} />
      </Page>
    </Document>
  );
};

export default MyDocument;
